import * as React from 'react';
import { Button } from '@dropbox/dig-components/buttons';
import { Menu } from '@dropbox/dig-components/menu';
import { Text } from '@dropbox/dig-components/typography';
/**
 * A section of notifications grouped with a title and separated by a divider from
 * other sections
 */
// prettier-ignore
export const Section = (props) => {
    const { title, actionButton, items, itemRenderFn } = props;
    if (!items || items.length === 0) {
        return null;
    }
    return (React.createElement(Menu.Segment, null,
        React.createElement(Menu.Row, { interactive: false, preferComposition: true },
            React.createElement(Menu.RowContent, null,
                React.createElement(Menu.RowTitle, null,
                    React.createElement(Text, { isBold: true, size: "small" }, title))),
            actionButton && (React.createElement(Menu.RowAccessory, null,
                React.createElement(Button, { ...actionButton, variant: "transparent", size: "small" }, actionButton.title)))),
        items.map(itemRenderFn)));
};
Section.displayName = 'NotificationSection';
